import { AnyRoute, createRoute, lazyRouteComponent } from '@tanstack/react-router'
import { bankUsersReportQueryOptions } from '~bank-reports/service/bankUsersReportQueryOptions'
import { bankUsersReportFilterParamsSchema } from '~bank-reports/types/BankUsersReport'

export const userReportRoute = <T extends AnyRoute>(indexRoute: T) =>
  createRoute({
    getParentRoute: () => indexRoute,
    path: 'user',
    validateSearch: (search) => bankUsersReportFilterParamsSchema.parse(search),
    loaderDeps: ({ search }) => search,
    loader: ({ cause, deps, context }) => {
      if (cause === 'stay') {
        return null
      }
      return (context as BPRoutingContext).queryClient.ensureQueryData(bankUsersReportQueryOptions(deps))
    },
    component: lazyRouteComponent(() => import('./UserReport'))
  })
